import request from 'superagent';
import baseRequest2 from '../baseApi2';

export interface ListmapParam {
    text: string;
}

export const fetchListModel = (params: ListmapParam): Promise<request.Response> =>
    baseRequest2(request.post(`/wordtag`).send(params));
export const fetchOnlineListModel = (params: ListmapParam): Promise<request.Response> =>
    baseRequest2(request.post(`wordtag/nptag`).send(params));
